<button
  class="btn btn-auto btn-primary btn--thin m-2 flex-row align-items-center"
  (click)="remove.emit()"
  data-cy="table-filter-badge"
  [matTooltip]="'tooltip.disable_filter' | translate"
>
  <i class="ri-close-line"> </i>
  {{ (filter.displayName | translate) || filter.name }}
</button>
